module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/perform.js
// module id = 250
// module chunks = 1